<header class="page-header">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      <div
        class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-phone mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-8-desktop">
        <bau365-user-salutation class="newsfeed-salutation" [familyName]="familyName" [givenName]="givenName">
        </bau365-user-salutation>
      </div>
      <div
        class="mdc-layout-grid__cell mdc-layout-grid__cell--span-1-phone mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-desktop newsfeed-search-field">
        <bau365-search-trigger
          class="newsfeed-search"
          [size]="size"
          [searchSuggestions]="searchSuggestions"
          (searchTermChange)="onSearchTermChanged($event)"
          (searchTermSubmit)="onSearchTermSubmitted()">
        </bau365-search-trigger>
      </div>
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 newsfeed-quicklinks">
        <bau365-quicklinks
          [quicklinks]="quicklinks"
          [fairId]="fairId"
          (clickQuicklink)="onClickQuicklink($event)"></bau365-quicklinks>
      </div>
    </div>
  </div>
</header>
